export default __webpack_public_path__ + "static/media/orgFreshStart.25359563.png";